import { TenantIsActiveOrderDeltaRequest, ProjectIsActiveResponse, ScopeUserRoleClient, ExportDataModel, ExportProjectsDataModel } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import store from 'base/reducer/store';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import { FetchingProjectItemsActionType, PersistProjectItemsActionType } from 'features/Persist/actionTypes';

export const getUserRolesAction = (projectId: number) => {
	const tenantId = getTenantId()!;
	const client = new ScopeUserRoleClient();
	return client.getAll(tenantId, projectId);
}

export const updateUserRolesAction = (projectId: number, delta: TenantIsActiveOrderDeltaRequest) => {
	const tenantId = getTenantId()!;
	const client = new ScopeUserRoleClient();
	return client.update(tenantId, projectId, delta);
}

export const exportUserRolesAction = (projectIds: number[], exportDataModel: ExportDataModel) => {
	const tenantId = getTenantId()!;
	const exportProjectsDataModel = new ExportProjectsDataModel({
		...exportDataModel,
		projectIds
	});
	const client = new ScopeUserRoleClient();
	return client.export(tenantId, exportProjectsDataModel);
}

export const persistUserRolesAction = async (projectId: number) => {
	const state = store.getState();

	if (state.persistedProjectTeam.projectMap[projectId]?.fetching) {
		return;
	}

	store.dispatch(setUserRolesFetchingAction(true, projectId));

	const bindedAction = getUserRolesAction.bind(null, projectId);
	const response = await tryCatchJsonByAction(bindedAction);

	if (response.success && response.items) {
		store.dispatch(setUserRolesAction(projectId, response.items || []));
	} else {
		store.dispatch(setUserRolesFetchingAction(false, projectId));
	}
}

// persist user roles redux

export const USER_ROLES_FETCHING = 'USER_ROLES_FETCHING';
export const USER_ROLES_SET = 'USER_ROLES_SET';

const setUserRolesFetchingAction = (fetching: boolean, projectId: number): FetchingProjectItemsActionType => {
	return {
		type: USER_ROLES_FETCHING,
		fetching,
		projectId
	}
}

const setUserRolesAction = (projectId: number, items: ProjectIsActiveResponse[]): PersistProjectItemsActionType<ProjectIsActiveResponse> => {
	return {
		type: USER_ROLES_SET,
		items,
		projectId
	}
}
